<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <p v-if="!showForm" class="font-weight-bold">
            El formulario solo puede ser llenado desde las 00:00 hasta las 20:00
        </p>
        <v-form ref="form" v-if="showForm" v-model="valid" lazy-validation>
            <p class="font-weight-bold">SINTOMATOLOGÍA</p>
            <p class="font-weight-bold">¿Presenta el día de hoy, alguno de los siguientes síntomas?</p>

            <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                    <p>1. Temperatura mayor a 37.5 grados centígrados ( fiebre ) *</p>
                    <v-select
                            v-model="covidPatientAlarm.response1"
                            :items="this.itemsElements"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                    <p>2. Tos</p>
                    <v-select
                            v-model="covidPatientAlarm.response2"
                            :items="this.itemsElements"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                    <p>3. Dificultad al respirar ( le falta el aire )</p>
                    <v-select
                            v-model="covidPatientAlarm.response3"
                            :items="this.itemsElements"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                    <p>4. Pérdida del gusto (no distingo sabores)</p>
                    <v-select
                            v-model="covidPatientAlarm.response4"
                            :items="this.itemsElements"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                    <p>5. Pérdida del olfato (no percibo olores)</p>
                    <v-select
                            v-model="covidPatientAlarm.response5"
                            :items="this.itemsElements"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                    <p>6. Rinorrea (catarro)</p>
                    <v-select
                            v-model="covidPatientAlarm.response8"
                            :items="this.itemsElements"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                    <p>7. Diarrea</p>
                    <v-select
                            v-model="covidPatientAlarm.response9"
                            :items="this.itemsElements"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <p class="font-weight-bold">EXPOSICIÓN</p>
          <v-layout>
            <v-flex xs12 sm10 offset-sm1>
              <span style="color: red">Las siguientes 2 preguntas se refieren a un CONTACTO CERCANO, en el que existan cualquiera de las siguientes condiciones:1) contacto a menos de dos metros de distancia, 2) contacto por más de 15 minutos y 3) contacto sin uso de mascarilla.</span>
            </v-flex>
          </v-layout>
          <br>
          <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                    <p>8. ¿En las últimas 24 horas ha estado en contacto con alguna persona que
                        tenia tos o fiebre? </p>
                    <v-select
                            v-model="covidPatientAlarm.response6"
                            :items="this.itemsElements"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                    <p>9. ¿En las últimas 24 horas en la casa o su trabajo, ha estado en contacto o existe sospecha de
                        alguna persona con coronavirus? </p>
                    <v-select
                            v-model="covidPatientAlarm.response7"
                            :items="this.itemsElements"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout>
            <v-flex xs12 sm6 offset-sm4>
                <div>
                    <v-btn :disabled="!valid"
                           @click="saveDataDialog" large color="primary">Guardar
                    </v-btn>
                </div>
            </v-flex>
        </v-layout>

        <v-dialog
                v-model="dialogError"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor verifique la información requerida para continuar.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogError = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogInactive"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <div align="center">
                        <p class="font-weight-bold">No puede continuar ya que su estado es NO APTO.</p>
                        <p class="font-weight-bold">Muy pronto se comunicarán con usted.</p>
                    </div>
                    <span></span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogInactive = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogErrorExist"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor ingrese los campos solicitados.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogErrorExist = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogErrorAgency"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor ingrese la información de agencia o sucursal.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogErrorAgency = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="dialogNotSuccess"
                max-width="500px"
                persistent
        >
            <v-card>
                <v-card-title>
                    <div align="center">
                        <p class="font-weight-bold">Quédate en casa, se comunicarán contigo dentro de las próximas 24
                            horas para darte
                            instrucciones.</p>
                    </div>
                </v-card-title>
                <v-card-text class="text--primary">
                    <div align="center">
                        <img src="../../assets/nosuccess.png" height="100px" width="100px">
                        <br>
                        Fecha y Hora: {{getFormattedDate(covidPatientAlarm.date)}}
                    </div>
                </v-card-text>
                <v-card-actions>
                    <div align="center">
                        <v-btn
                                color="primary"
                                text
                                @click="reloadPage"
                        >
                            Cerrar
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
                persistent
        >
            <v-card>
                <v-card-title>
                    <div align="center">
                        <p class="font-weight-bold">Te esperamos en el Trabajo</p>
                    </div>
                </v-card-title>
                <v-card-text class="text--primary">
                    <div align="center">
                        <img src="../../assets/success.png" height="100px" width="100px">
                        <br>
                        <qrcode-vue
                                :value="identification + ' | ' + getFormattedDate(covidPatientAlarm.date)+ ' | ' +covidPatientAlarm.covidPatient.name+' '+covidPatientAlarm.covidPatient.lastName"  ></qrcode-vue>
                        <br>
                        Fecha y Hora: {{getFormattedDate(covidPatientAlarm.date)}} {{covidPatientAlarm.covidPatient.name}} {{covidPatientAlarm.covidPatient.lastName}}
                    </div>
                </v-card-text>
                <v-card-actions>
                    <div align="center">
                        <v-btn
                                color="primary"
                                text
                                @click="reloadPage"
                        >
                            Cerrar
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogInfo"
                fullscreen=""
        >
            <v-card
                    class="mx-auto"
                    max-width="400"
            >
                <v-img
                        class="white--text align-end"
                        height="200px"
                        src="https://inscora-images.s3.amazonaws.com/covid-inscora.jpeg"
                >
                </v-img>
                <v-layout v-if="!showForm">
                    <v-flex xs12 sm10 offset-sm1>
                        <v-card-text class="text--primary">
                            <p class="font-weight-bold">
                                Por falta de llenado de la ficha en plazo determinado por su empleador, la misma ya no
                                está disponible y usted no podrá acercarse a su trabajo hasta que pueda cumplir con una
                                nueva ficha . </p>
                            <!--                            <p class="font-weight-bold">-->
                            <!--                                El formulario solo puede ser llenado desde las 00:00 horas hasta las 20:00 horas.-->
                            <!--                            </p>-->
                            <br>
                            <p class="font-weight-bold">
                                Gracias!
                            </p>
                        </v-card-text>
                    </v-flex>
                </v-layout>
                <v-layout v-if="showForm">
                    <v-flex xs12 sm10 offset-sm1>
                        <v-card-text class="text--primary">
                            <p class="font-weight-bold">INSCORA CENTRO DE ALARMAS SÍNTOMAS COVID19</p>


                            <div style="text-align : justify;">Previo al inicio de su jornada de trabajo se necesita que
                                de manera veraz responda al siguiente cuestionario. En caso de que alguna pregunta sea
                                positiva, se iniciará de manera inmediata un programa de salud que redundará en su
                                beneficio y de su familia, además garantizará que en su centro de trabajo se desarrollen
                                las actividades de manera segura.
                            </div>
                            <br>
                            <div style="text-align : justify;">SE GARANTIZA LA CONFIDENCIALIDAD DE ESTA INFORMACIÓN,
                                ESTE CUESTIONARIO DEBERÁ SER LLENADO TODOS LOS DÍAS DE MANERA OBLIGATORIA. DE PRESENTAR
                                ALGUN SÍNTOMA, FAVOR NO SE PRESENTE EN SU LUGAR DE TRABAJO Y NOTIFIQUE A SU JEFE
                                INMEDIATO
                            </div>
                            <br>


                            <p class="font-weight-bold">Por favor complete la siguiente información para comenzar.</p>
                            <v-form ref="form1" v-model="validDialog" lazy-validation>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <v-text-field
                                                name="cedula"
                                                label="Cédula/Pasaporte"
                                                id="cedula"
                                                :rules="[v => !!v || 'La identificación es requerida', v => (v && v.length <= 15) || 'El valor debe tener menos de 15 caracteres']"
                                                required
                                                v-model="identification"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="agencyForm">
                                    <v-flex xs12 sm10 offset-sm1>
                                        <v-select
                                                v-model="agency"
                                                :items="$store.state.companyAgencies"
                                                item-value="id"
                                                item-text="name"
                                                :rules="[v => !!v || 'Agencia es requerida']"
                                                label="Sucursal/agencia/planta"
                                                return-object
                                                persistent-hint
                                                required
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <div v-if="identificationForm">
                                    <v-layout>
                                        <v-flex xs12 sm10 offset-sm1>
                                            <v-text-field
                                                    name="nombre"
                                                    label="Nombre"
                                                    id="nombre"
                                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                                                    v-model="covidPatient.name"
                                                    required
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs12 sm10 offset-sm1>
                                            <v-text-field
                                                    name="apellido"
                                                    label="Apellido"
                                                    id="apellido"
                                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                                                    v-model="covidPatient.lastName"
                                                    required
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs12 sm10 offset-sm1>
                                            <v-select
                                                    v-model="covidPatient.company"
                                                    :items="$store.state.companies"
                                                    item-value="id"
                                                    item-text="name"
                                                    :rules="[v => !!v || 'Cliente es requerido']"
                                                    label="Cliente"
                                                    @change="loadAgency"
                                                    return-object
                                                    persistent-hint
                                                    required
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs12 sm10 offset-sm1>
                                            <v-select
                                                    v-model="covidPatient.agency"
                                                    :items="$store.state.companyAgencies"
                                                    item-value="id"
                                                    item-text="name"
                                                    :rules="[v => !!v || 'Agencia es requerida']"
                                                    label="Sucursal/agencia/planta"
                                                    return-object
                                                    hint="Donde está habitualmente asignado(a)."
                                                    persistent-hint
                                                    required
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    text
                                    v-if="identificationForm"
                                    :disabled="!validDialog"
                                    @click="dialogInitSaving=true"
                            >
                                Continuar
                            </v-btn>
                            <v-btn
                                    color="primary"
                                    text
                                    v-if="!identificationForm && !agencyForm"
                                    :disabled="(!validDialog && !identificationForm) "
                                    @click="iniciarEncuesta"
                            >
                                Continuar
                            </v-btn>
                            <v-btn
                                    color="primary"
                                    text
                                    v-if="agencyForm"
                                    :disabled="!validDialog"
                                    @click="dialogInitUpdating=true"
                            >
                                Continuar
                            </v-btn>
                        </v-card-actions>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogErrorCovidForm"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Para llenar el formulario de alarmas, primero debe llenar la ficha inicial.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogErrorCovidForm = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogInfoAlarmForm"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Usted ya ha llenado la ficha de alarma el día de hoy.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogInfoAlarmForm=false, dialogAdvertisement=true"
                    >
                        Regresar
                    </v-btn>
                    <v-btn
                            color="primary"
                            text
                            @click="continuarEncuestaConAviso()"
                    >
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogAceptAlarmForm"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Está seguro que desea continuar con los siguientes datos ingresados? Identificación: {{this.identification}}</span>
                </v-card-title>
                <v-card-actions>

                    <v-btn
                            color="primary"
                            text
                            @click="dialogAceptAlarmForm = false"
                    >
                        Regresar
                    </v-btn>
                    <v-btn
                            color="primary"
                            text
                            @click="continuarEncuesta()"
                    >
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogConfirmSaveAlert"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Está seguro de que desea enviar toda la información ingresada?</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogConfirmSaveAlert = false"
                    >
                        Regresar
                    </v-btn>
                    <v-btn
                            color="primary"
                            text
                            @click="saveData()"
                    >
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogInitSaving"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Está seguro que desea continuar con los siguientes datos ingresados? Identificación: {{this.identification}} </span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogInitSaving = false"
                    >
                        Regresar
                    </v-btn>
                    <v-btn
                            color="primary"
                            text
                            @click="iniciarEncuestaGuardaNuevo()"
                    >
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogInitUpdating"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Está seguro que desea continuar con los siguientes datos ingresados? Identificación: {{this.identification}} </span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogInitUpdating = false"
                    >
                        Regresar
                    </v-btn>
                    <v-btn
                            color="primary"
                            text
                            @click="iniciarEncuestaUpdate()"
                    >
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogRequired"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor responda todas las preguntas.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogRequired = false"
                    >
                        Regresar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogAdvertisement"
                fullscreen
        >
            <v-card>
                <v-card-title>
                    <div style="width: 100%"><p class="font-weight-bold" style="text-align: center">{{this.advertisementText}}</p></div>
                    <br>
                    <div style="width: 100%; text-align: center">
                    <img :src="this.advertisement" style="max-height: 500px; max-width: 500px;" width="100%" height="100%" alt="">
                    </div>
                    <br>
                    <br>
                    <br>
                    <div align="center" style="width: 100%;padding-bottom: 50%">
                        <img src="../../assets/inscora-logo-principal.png" width="250px" height="250px" alt="">
                        <br>
                        <v-progress-linear style="padding-bottom: 10px"
                                           color="light-blue"
                                           indeterminate
                                           striped
                        ></v-progress-linear>
                    </div>
                </v-card-title>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>

    import CovidPatientAlarm from "../../model/CovidPatientAlarm";
    import CovidPatient from "../../model/CovidPatient";
    import QrcodeVue from 'qrcode.vue'
    import CovidEntity from "../../model/CovidEntity";

    export default {
        components: {
            QrcodeVue,
        },
        props: ['number'],
        data() {
            return {
                e1: 1,
                identification: "",
                identificationForm: false,
                agencyForm: false,
                agency: "",
                checkbox: false,
                editable: true,
                covidPatientAlarm: new CovidPatientAlarm(),
                covidPatient: new CovidPatient(),
                search: '',
                valid: false,
                validDialog: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                dialogSuccess: false,
                dialogNotSuccess: false,
                dialogError: false,
                dialogErrorExist: false,
                dialogErrorAgency: false,
                dialogAdvertisement: false,
                advertisement:"",
                advertisementText:"",
                dialogInactive: false,
                dialogCondition: false,
                dialogSucess: false,
                dialogRequired: false,
                dialogErrorCovidForm: false,
                dialogInfoAlarmForm: false,
                dialogInfo: true,
                dialogAceptAlarmForm: false,
                dialogConfirmSaveAlert: false,
                dialogInitSaving: false,
                dialogInitUpdating: false,
                showForm: true,
                itemsElements: ['SI', 'NO'],
                emailRules: [
                    v => !!v || 'El email es requerido',
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El email debe ser valido'
                ],

            };
        },

        computed: {},
        methods: {
            reloadPage() {
                window.location.reload(false);
                this.dialogSuccess = false
                this.dialogNotSuccess = false
            },

            iniciarEncuesta() {
                this.identification = this.identification.trim()
                if (this.$refs.form.validate()) {
                    // Verifica si tiene registro de ficha inicial
                    this.$store.dispatch('existCovid', this.identification).then(
                        response => {
                            if (response.data == true) {
                                this.dialogErrorCovidForm = false
                                // Verifica si ya lleno la ficha de alarma el dia de hoy
                                this.$store.dispatch('hasCovidAlarmToday', this.identification).then(
                                    response => {
                                        if (response.data == true) {
                                            this.dialogInfoAlarmForm = true
                                        } else {
                                            this.dialogInfoAlarmForm = false
                                            this.dialogAceptAlarmForm = true
                                        }
                                    }
                                )
                            } else {
                                this.dialogErrorCovidForm = true
                            }
                        }
                    )
                }
            },

            iniciarEncuestaGuardaNuevo() {
                if (this.$refs.form.validate()) {
                    this.dialogInitSaving = false
                    this.covidPatient.status = 'ACTIVO'
                    this.covidPatient.identification = this.identification
                    this.$store.dispatch('addCovidPatienFromAlarm', this.covidPatient).then(
                        response => {
                            this.covidPatientAlarm.covidPatient = response.data
                            this.dialogInfo = false
                            this.dialogAdvertisementTimer()
                            this.topFunction()
                        },
                        error => {
                            this.$store.state.progress = false;
                            this.$store.state.dialogError = true;
                            this.$store.state.dialogErrorMessage = 'No se pudo crear el Paciente verifique que no exista'
                        }
                    );
                }
            },
            continuarEncuesta() {
                this.dialogAceptAlarmForm = false
                this.$store.dispatch('getCovidPatientByIdentification', this.identification).then(
                    response => {
                        if (response.data != "") {
                            this.covidPatientAlarm.covidPatient = response.data
                            if (this.covidPatientAlarm.covidPatient.agency == null) {
                                this.$store.dispatch('getCompanyAgenciesByCompany', this.covidPatientAlarm.covidPatient.company.id).then(response => {
                                    this.agencyForm = true
                                    this.dialogErrorAgency = true
                                })
                            } else if (this.covidPatientAlarm.covidPatient.status == 'INACTIVO') {
                                this.dialogInactive = true
                            } else {
                                this.dialogInfo = false
                                this.dialogAdvertisementTimer()
                                this.topFunction()
                            }
                        } else {
                            this.dialogErrorExist = true
                            this.identificationForm = true
                        }
                    },
                    error => {
                        this.$store.state.progress = false;
                        this.$store.state.dialogError = true;
                    }
                );
            },
            continuarEncuestaConAviso() {
                this.dialogInfoAlarmForm = false;
                this.dialogAceptAlarmForm = true;
            },

            iniciarEncuestaUpdate() {
                if (this.$refs.form.validate()) {
                    this.dialogInitUpdating = false
                    this.covidPatientAlarm.covidPatient.agency = this.agency
                    this.$store.dispatch('updateCovidPatientFormAlarm', this.covidPatientAlarm.covidPatient).then(
                        response => {
                            this.covidPatientAlarm.covidPatient = response.data
                            this.dialogInfo = false
                            this.dialogAdvertisementTimer()
                            this.topFunction()
                        },
                        error => {
                            this.$store.state.progress = false;
                            this.$store.state.dialogError = true;
                            this.$store.state.dialogErrorMessage = 'No se pudo crear el Paciente verifique que no exista'
                        }
                    );
                }
            },
            cleanData() {
                this.$refs.form.reset();
                this.covidPatientAlarm = new CovidPatientAlarm();
                this.valid = false;
                this.dialog = false;
            },

            saveDataDialog() {
                if (this.covidPatientAlarm.response1 == '' || this.covidPatientAlarm.response2 == '' || this.covidPatientAlarm.response3 == '' || this.covidPatientAlarm.response4 == '' || this.covidPatientAlarm.response5 == '' || this.covidPatientAlarm.response6 == '' || this.covidPatientAlarm.response7 == '' || this.covidPatientAlarm.response8 == '' || this.covidPatientAlarm.response9 == '') {
                    this.dialogRequired = true
                }else{
                    this.dialogConfirmSaveAlert = true
                }
            },

            saveData() {
                if (this.$refs.form.validate()) {
                    this.dialogConfirmSaveAlert = false
                    this.$store.dispatch('addCovidPatientAlarm', this.covidPatientAlarm).then(
                        response => {
                            this.covidPatientAlarm = response.data
                            if (this.covidPatientAlarm.response1 == 'NO' && this.covidPatientAlarm.response2 == 'NO' && this.covidPatientAlarm.response3 == 'NO' && this.covidPatientAlarm.response4 == 'NO' && this.covidPatientAlarm.response5 == 'NO' && this.covidPatientAlarm.response6 == 'NO' && this.covidPatientAlarm.response7 == 'NO'  && this.covidPatientAlarm.response8 == 'NO'  && this.covidPatientAlarm.response9 == 'NO') {
                                this.dialogSuccess = true
                            } else {
                                //Se incativa el paciente si es que presenta sintomás
                                this.dialogNotSuccess = true
                                this.$store.dispatch('sendCovidPatientAlarmMail', this.covidPatientAlarm.id)
                            }
                        },
                        error => {
                            this.$store.state.progress = false;
                            this.$store.state.dialogError = true;
                            this.$store.state.dialogErrorMessage = 'No se pudo crear la alarma verifique la información'
                        }
                    );
                }
            },
            topFunction() {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            },
            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (true) {
                        // Para Safari
                        if (!(dateReg instanceof Date)) {
                            var b = dateReg.toString().split(/\D/);
                            date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                        } else {
                            date = new Date(dateReg);
                        }
                }  else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
                return str;
            },
            loadAgency() {
                this.$store.dispatch('getCompanyAgenciesByCompany', this.covidPatient.company.id).then(response => {
                })
            },
            dialogAdvertisementTimer(){
                this.dialogAdvertisement = true
                const self = this;
                self.advertisementText= "Por su seguridad tomar en cuenta los siguientes consejos para evitar contagios"
                setTimeout(function(){
                    self.advertisementText= "Use su mascarilla"
                    self.advertisement = "https://inscora-images.s3.amazonaws.com/alarma+covid/USO+DE+MASCARILLA+.jpg"
                }, 4000);
                setTimeout(function(){
                    self.advertisementText= "Mantenga una distancia de 2 metros entre personas"
                    self.advertisement = "https://inscora-images.s3.amazonaws.com/alarma+covid/DISTANCIAMIENTO+INTERPERSONAL.jpg"
                }, 8000);
                setTimeout(function(){
                    self.advertisementText= "Higiene de manos (lavado con agua y jabón por 60 seg. / desinfección con alcohol gel por 30 seg.)"
                    self.advertisement = "https://inscora-images.s3.amazonaws.com/alarma+covid/LAVADO+DE+MANOS+.jpg"
                }, 12000);
                setTimeout(function(){
                    self.advertisementText= "Mejorar ventilación en los lugares donde se encuentra"
                    self.advertisement = "https://inscora-images.s3.amazonaws.com/alarma+covid/MEJORAR+VENTILACI%C3%93N.jpeg"
                }, 16000);
                setTimeout(function(){
                    self.dialogAdvertisement = false
                }, 20000);
            }
        },
        created() {
            this.$store.dispatch('getCompanies').then(response => {
            }, error => {
                this.$store.state.dialogError = true
            })

            let d = new Date();
            let n = d.getHours();
            if (n > 0 && n < 20) {
                this.showForm = true;
            } else {
                this.showForm = false;
            }
        },
    }
</script>

<style scoped>
    li {
        list-style: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/covid/CovidAlarmRegister.vue